module.exports = "<div class=home-column> <div class=home-column-icon> <div> <i class=\"fa {{ $ctrl.icon }}\"></i> </div> </div> <div class=home-column-list> <div class=home-column-header> {{ $ctrl.title }} </div> <div ng-repeat=\"link in $ctrl.links\" ng-if=!link.hideLink class=home-link> <a ng-if=link.url ui-sref=\"{{ link.url }}\"> {{ link.text }} </a> <a ng-if=link.href ng-href=\"{{ link.href }}\" target=_blank> {{ link.text }} </a> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/home/home-column/home-column.html
// module id = 389
// module chunks = 0